export const navItems = [
  { label: 'Solutions', href: '#solutions' },
  { label: 'Benefits', href: '#benefits' },
  { label: 'How it works', href: '#how-it-works' },
  { label: 'Contact', href: '#contact' },
]

export const audience = [
  'Car washes',
  'Gyms and fitness studios',
  'Oil change locations',
  'Tire shops',
  'Retail stores',
  'Community centers',
  'Any location with waiting time and customer traffic',
]

export const solutions = [
  {
    title: 'Coffee Machine',
    text: 'Premium bean-to-cup coffee machines for high-traffic locations.',
  },
  {
    title: 'Protein Shake Machine',
    text: 'Perfect for gyms, wellness spaces, and health-focused businesses.',
  },
  {
    title: 'Food Kiosk',
    text: 'Convenient grab-and-go food solutions for busy customer environments.',
  },
]

export const benefits = [
  'No upfront cost for the business owner',
  'Additional monthly revenue stream',
  'Modern customer experience',
  'No extra staff required',
  'Low operational involvement',
  'Revenue share or fixed rent options',
]

export const steps = [
  {
    title: 'Submit your location',
    text: 'Tell us about your business, traffic, and customer flow.',
  },
  {
    title: 'We evaluate the fit',
    text: 'We review traffic, layout, and recommend the best vending solution.',
  },
  {
    title: 'We install for free',
    text: 'Our team handles delivery, setup, and launch at no cost to you.',
  },
  {
    title: 'You earn revenue',
    text: 'We operate and service the machine while you earn from the placement.',
  },
]

export const faq = [
  {
    q: 'How much does installation cost?',
    a: 'Installation is free for qualified business locations.',
  },
  {
    q: 'Who handles maintenance and restocking?',
    a: 'We do. Our team manages service, maintenance, and operations.',
  },
  {
    q: 'What types of businesses are a good fit?',
    a: 'Car washes, gyms, oil change shops, retail stores, community centers, and any location with steady foot traffic and waiting time.',
  },
  {
    q: 'How do we make money?',
    a: 'Depending on the location, we offer either revenue sharing or a fixed rental model.',
  },
]